import { PremiumFeatureRoute } from './PremiumFeatureRoute';

export default PremiumFeatureRoute;
